<template>
  <div>
    <span class="margin">
      <font-awesome-icon :icon="['far', 'thumbs-up']" aria-hidden="true" />
      {{ thought.vote_nnp_pro }}
      <span class="visually-hidden">{{ thought.vote_nnp_pro }}</span>
    </span>
    <span class="margin">
      <font-awesome-icon :icon="['far', 'thumbs-down']" aria-hidden="true" />
      {{ thought.vote_nnp_con }}
      <span class="visually-hidden">{{ thought.vote_nnp_con }}</span>
    </span>
    <span class="margin">
      <font-awesome-icon :icon="['far', 'chart-bar']" aria-hidden="true" />
      {{ thought.votesum }}
      <span class="visually-hidden">{{ thought.votesum }}</span>
    </span>
    <span class="margin">
      <font-awesome-icon :icon="['far', 'comment']" aria-hidden="true" />
      {{ thought.commentcount }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'VoteStatsShort',
  props: {
    thought: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style>
.margin {
  margin-right: 5px;
}
</style>
